import { useRollCompetitionEntriesByCycleId } from '@/api/roll-competition-entries';
import { useRollCompetitions } from '@/api/roll-competitions';
import { rollCompetitionLeaderboardColumns } from '@/constants/roll-competition-leaderboard';
import { TableWithPagination } from '@starsoft/common/components';

export default function RollCompetitionContentRendererInfo() {
  const { rollCompetition } = useRollCompetitions();
  const {
    error,
    fetchNextPage,
    fetchPreviousPage,
    isPending,
    page,
    refetch,
    rollCompetitionEntries,
    setCurrentPage,
  } = useRollCompetitionEntriesByCycleId({
    cycleId: rollCompetition?.cycle?.id as bigint,
  });

  return (
    <TableWithPagination
      data={rollCompetitionEntries}
      error={error}
      columns={rollCompetitionLeaderboardColumns}
      fetchNextPage={fetchNextPage}
      fetchPreviousPage={fetchPreviousPage}
      page={page}
      isLoading={isPending}
      refetch={refetch}
      setCurrentPage={setCurrentPage}
    />
  );
}
